import { Box, Button, Typography } from '@mui/material'
import IDVerifiedChip from '@/components/ui/IDVerifiedChip'
import RedFlagChip from '@/components/ui/RedFlagChip'
import TabButton from '@/components/ui/TabButton'
import type { PatientDetails } from '@/services/patients'

interface HeaderProps {
  patient: PatientDetails
  activeTab: 'overview' | 'timeline'
  onTabChange: (tab: 'overview' | 'timeline') => void
  onVerifyId: () => void
  isVerifyingId?: boolean
  onRunDuplicateCheck: () => void
  isRunningDuplicateCheck?: boolean
  canRunDuplicateCheck?: boolean
  readOnly?: boolean
}

export default function Header({
  patient,
  activeTab,
  onTabChange,
  onVerifyId,
  isVerifyingId,
  onRunDuplicateCheck,
  isRunningDuplicateCheck,
  canRunDuplicateCheck,
  readOnly
}: HeaderProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* Name and Badges */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Typography variant='pageTitle'>
          {patient.firstName} {patient.lastName}
        </Typography>
        <IDVerifiedChip verified={patient.idVerified} />
        {patient.hasRedFlag && <RedFlagChip />}
      </Box>

      {/* Tabs */}
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <TabButton active={activeTab === 'overview'} onClick={() => onTabChange('overview')}>
          Patient overview
        </TabButton>
        <TabButton active={activeTab === 'timeline'} onClick={() => onTabChange('timeline')}>
          Timeline
        </TabButton>
        {!readOnly && (
          <Button
            variant='secondary'
            onClick={onVerifyId}
            disabled={isVerifyingId || !patient.userHash || patient.idVerified}
            loading={isVerifyingId}
          >
            Verify ID
          </Button>
        )}
        {canRunDuplicateCheck && (
          <Button
            variant='secondary'
            onClick={onRunDuplicateCheck}
            disabled={isRunningDuplicateCheck}
            loading={isRunningDuplicateCheck}
          >
            Run duplicate check
          </Button>
        )}
      </Box>
    </Box>
  )
}
